import React from 'react';
import { Card, Empty } from 'antd';
import moment from 'moment';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar
} from 'recharts';

const BandwidthConsumeChart = ({ data }) => {
  const allZero = !data.some(d => d.bandwidth_consumed > 0);
  let yMax = 1000;
  if (!allZero) {
    const maxVal = Math.max(...data.map(d => Number(d.bandwidth_consumed)), 1000);
    if (maxVal <= 1000) yMax = 1000;
    else if (maxVal <= 2000) yMax = 2000;
    else if (maxVal <= 5000) yMax = 5000;
    else if (maxVal <= 10000) yMax = 10000;
    else yMax = Math.ceil(maxVal / 10000) * 10000;
  }
  const formatBandwidth = v => v >= 1000000 ? `${(v/1000000).toFixed(2)} TB` : v >= 1000 ? `${(v/1000).toFixed(2)} GB` : `${Number(v).toFixed(2)} MB`;
  const formatDate = dateStr => moment(dateStr).format('MMM DD');

  return (
    <Card className="side-panel align-center" style={{ minHeight: '500px' }}>
      {!allZero ? (
        <ResponsiveContainer>
          <BarChart data={data} margin={{ top: 20, right: 30, left: 40, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tickFormatter={formatDate} />
            <YAxis domain={[0, yMax]} tickFormatter={formatBandwidth} />
            <Tooltip formatter={v => formatBandwidth(Number(v))} labelFormatter={formatDate} />
            <Bar dataKey="bandwidth_consumed" fill="#377fae" barSize={60} />
          </BarChart>
        </ResponsiveContainer>
      ) : <Empty />}
    </Card>
  );
};

export default BandwidthConsumeChart;   